import React, { useEffect } from 'react';
import LexisNexisReport from '../components/Orders/ViewLexisNexisReport';

const LexisNexisReportPage = () => {
  return <LexisNexisReport />;
};

export default LexisNexisReportPage;
